import { constants, sentry } from 'common/helpers'
import request from 'sb-request'

import queueQuery from './queue.graphql'
import addToQueueMutation from './addToQueue.graphql'


export const modifyItems = (queue) => {
  let { items, recommendationTag } = queue || {}

  // TODO OMG backend sends "null" sometimes....
  if (!items) {
    items = []
  }

  const newItems = items.map((item) => {
    const statuses = [ 'skipped', 'locked', 'shipped', 'paused' ]

    statuses.forEach((value) => {
      item[value] = item.status.some((status) => status === constants.queueItemStatuses[value])
    })

    if (!item.status) {
      item.status = []
    }

    if (!item.products) {
      item.products = []
    }

    item.disabled = (
      !item.status.some((status) => [ 'empty', 'product', 'free' ].includes(status))
      && (
        item.skipped
        || item.locked
        || item.shipped
      )
    )

    item.empty = item.products.length === 0

    item.products = item.status.map((status, index) => {
      let product = item.products[index] || {}

      const isEmpty = !product.id
      const isUnavailable = status === constants.queueItemStatuses.unavailable
      const isFree = (
        status === constants.queueItemStatuses.free
        || status === constants.queueItemStatuses.redeemed
      )
      // it's for correct work of moveProduct / removeProduct methods
      const disabled = [ 'skipped', 'locked', 'shipped' ].includes(status) || isEmpty

      const data = {
        ...product,
        status,
        isEmpty,
        isFree,
        isUnavailable,
        disabled,
      }

      // SCNT-5156: abTest queueEmptyPlusCell to show plus in all empty cells
      // not locked for adding so check the month is active - !item.disabled
      if (isEmpty && !item.disabled) {
        data.isAvailableForAdd = true
      }

      return data
    })

    if (item.products.some((product) => !product)) {
      sentry.captureException('Missed Queue Product', {
        extra: {
          responseQueue: queue,
          modifiedProducts: item.products,
        },
      })

      item.products = item.products.filter((product) => product)
    }

    return item
  })

  return {
    recommendationTag,
    items: newItems,
  }
}

export const fetch = ({ limit } = {}) =>
  request.post('graphql?name=queue', {
    body: {
      query: queueQuery,
      variables: {
        limit,
      },
    },
    modifyResult: ({ queue }) => modifyItems(queue),
  })

// TODO add replacement property to the ordersQuery when SB-2161 will be done - added 25/06/2020 by @mikediam
const add = ({ input }) =>
  request.post('graphql?name=addToQueue', {
    body: {
      query: addToQueueMutation,
      variables: {
        input,
      },
    },
    withNestedErrors: true,
    withErrorModal: false,
    modifyResult: ({ addToQueue: { queue, productsAdded } }) => {
      const { items, recommendationTag } = modifyItems(queue)

      return {
        items,
        recommendationTag,
        productsAdded,
      }
    },
  })


export default {
  add,
  fetch,
  modifyItems,
}
